type CurrentTextDimensions = {
  currentWidth: number
  currentHeight: number
  currentContentWidth: number
  currentContentHeight: number
  currentText: string
}

type EditorTextDimensions = {
  editorWidth: number
  editorHeight: number
  editorContentWidth: number
  editorContentHeight: number
  editorText: string
}

type SizeData = {
  currentTextDimensions: CurrentTextDimensions
  editorTextDimensions: EditorTextDimensions
}

export const checkDiscrepancies = (sizeData: SizeData): boolean => {
  const { currentTextDimensions, editorTextDimensions } = sizeData
  const {
    currentWidth,
    currentHeight,
    currentContentWidth,
    currentContentHeight,
  } = currentTextDimensions
  const { editorWidth, editorHeight, editorContentWidth, editorContentHeight } =
    editorTextDimensions

  // Compare all dimensions directly
  const hasDimensionDiscrepancies =
    currentWidth !== editorWidth ||
    currentHeight !== editorHeight ||
    currentContentWidth !== editorContentWidth ||
    currentContentHeight !== editorContentHeight

  return hasDimensionDiscrepancies
}
